import { render, staticRenderFns } from "./PlanDescBlock.vue?vue&type=template&id=bec1768c&"
import script from "./PlanDescBlock.vue?vue&type=script&lang=js&"
export * from "./PlanDescBlock.vue?vue&type=script&lang=js&"
import style0 from "./PlanDescBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol})
